import { render } from "./TealPill.vue?vue&type=template&id=be11f2f8&scoped=true"
import script from "./TealPill.vue?vue&type=script&lang=js"
export * from "./TealPill.vue?vue&type=script&lang=js"

import "./TealPill.vue?vue&type=style&index=0&id=be11f2f8&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be11f2f8"]])

export default __exports__